export default {
  path: '/ratio-deal',
  meta: {
    title: '预约订货',
    // keepAlive:true
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-deal`),
}



// WEBPACK FOOTER //
// ./src/views/RatioPin/router.js